import { BaseDto } from './base.dto';

export class PoSystemStatusDto extends BaseDto {
  name: string;
}
